var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1691945918840,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896 832h-64v-64h64a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64H320a64 64 0 0 0-64 64v64H192V128a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v576a128 128 0 0 1-128 128z",
    fill: "#2e8f79",
    "p-id": 5903
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M704 1024H128a128 128 0 0 1-128-128V320a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v576a128 128 0 0 1-128 128zM128 256a64 64 0 0 0-64 64v576a64 64 0 0 0 64 64h576a64 64 0 0 0 64-64V320a64 64 0 0 0-64-64z",
    fill: "#2e8f79",
    "p-id": 5904
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1a4910e757e7fef3750b6d57ce517c84.svg";
export { ForwardRef as ReactComponent };